import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect, Switch, Route } from 'dva/router';
import DocumentTitle from 'react-document-title';
import styles from './UserLayout.less';
import { getRoutes } from '../utils/utils';

// const links = [{
//   title: '帮助',
//   href: '',
// }, {
//   title: '隐私',
//   href: '',
// }, {
//   title: '条款',
//   href: '',
// }];

// const copyright = <div>Copyright <Icon type="copyright" /> 2018 网易出品</div>;

class UserLayout extends React.PureComponent {
  static childContextTypes = {
    location: PropTypes.object,
  }
  getChildContext() {
    const { location } = this.props;
    return { location };
  }
  getPageTitle() {
    const { routerData, location } = this.props;
    const { pathname } = location;
    let title = '效果营销平台';
    if (routerData[pathname] && routerData[pathname].name) {
      title = `${routerData[pathname].name} - 效果营销平台`;
    }
    return title;
  }

  setScrollFlag() {
    sessionStorage.setItem('scrollFlag', true);
  }

  render() {
    const { routerData, match } = this.props;

    return (
      <DocumentTitle title={this.getPageTitle()}>
        <div className={styles.container}>
          <div className={styles.header}>
              <div className={styles.middle}>
                  <Link to="/index">
                    <div className={styles.logo}>
                        <h1>网易麦穗广告</h1>
                    </div> 
                  </Link>
                  <div className={styles.login}>
                    <Link to="/index">
                      <div className={styles.bt} onClick={this.setScrollFlag}>立即开户</div>
                    </Link>
                  </div>
              </div>
          </div>
          <div className={styles.banner}>
              <div className={styles.middle}> 
                <div className={styles.pic}></div>  
                <div className={styles.title}>  
                  <h2>网易麦穗广告</h2>
                  <h3>助力效果营销，实现大“麦”目标</h3>
                </div>
                <div className={styles.item}>
                    <Switch>
                      {getRoutes(match.path, routerData).map(item =>
                        (
                          <Route
                            key={item.key}
                            path={item.path}
                            component={item.component}
                            exact={item.exact}
                          />
                        )
                      )}
                      <Redirect exact from="/user" to="/user/login" />
                    </Switch>
                </div>
              </div> 
          </div>
          <div className={styles.footer}>
              <div className={styles.copyright}>
                  <span>Copyright © 2018 &nbsp;&nbsp; | &nbsp;&nbsp; 网易出品</span>
                  {/**
                    <span className={styles.help}>帮助 &nbsp;&nbsp; | &nbsp;&nbsp; 隐私 &nbsp;&nbsp; | &nbsp;&nbsp; 条款</span>
                  **/}
              </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

export default UserLayout;
